import { SET_OTHER_CREDENTIALS } from './type';

const initialState = {
    otherCredentials: []
};

const otherCredentialsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_OTHER_CREDENTIALS:
            return {
                ...state,
                otherCredentials: [...payload]
            };
        default:
            return state;
    }
};

export default otherCredentialsReducer;
